export const REDUCER_NAME = "matchLineup";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_MATCHLINEUP = `${REDUCER_NAME}/SET_MATCHLINEUP`;
export const RESET_MATCHLINEUP = `${REDUCER_NAME}/RESET_MATCHLINEUP`;

export const getKey = (data) => `${data.matchId}`;
